<template>
    <div>
        <div class="box">
            <BInputDateRange
                v-model="createTime"
                to-text="至"
                @startDateChange="startDateChange"
                @endDateChange="endDateChange"
            />
            <BBtnSecondary
                :img-src="require('@/assets/filter.png')"
                :clicked="doSearch"
                hidden-key="true"
                btn-txt="筛选"
                style="margin-left: 30px;"
            />
        </div>
        <div class="search-result">
            <Table
                :headers="headers"
                :tableData="pageList"
                :length="totalPages"
                :total-visible="7"
                :page-num="page"
                v-model="page"
                @input="doSearch(false)"
            >
            </Table>
        </div>
    </div>
</template>
<script>
import { operationLogSearch } from "@/api/operationLog";
import Table from "../../components2/Table";
import BInputDateRange from "../../components2/BInputDateRange";
import BBtnSecondary from "../../components2/BBtnSecondary";
export default {
  name: "AccountManagement",
  components: {
    Table,
    BInputDateRange,
    BBtnSecondary,
  },
  data: () => ({
    deleteDialogFlag: false,
    // loading: false,
    id: 0,
    totalPages: 0,
    page: 1,
    pageCount: 10,
    totalCount: 0,
    headers: [
      { text: "ID", value: "indexNum", sortable: false, align: "center", width: '4%' },
      { text: "操作账号", value: "loginId", sortable: false, align: "center", width: '13%' },
      { text: "操作IP", value: "operationIp", sortable: false, align: "center", width: '13%' },
      { text: "操作模块", value: "moduleName", sortable: false, align: "center", width: '20%' },
      { text: "操作内容", value: "content", sortable: false, align: "center", width: '25%' },
      { text: "操作时间", value: "operationTime", sortable: false, align: "center" },
    ],
    pageList: [],
    loginUserId: sessionStorage.getItem('userId'),
    createTime: {
        from: "",
        to: "",
    },
  }),
  created() {
    // 页面初期化
    this.comUtils.saveStorage(this.$store);
  },
  mounted() {
    this.searchPageList();
    this.doSearch(true);
  },
  methods: {
    doSearch (flag) {
        if (flag) {
          this.totalPages = 0
          this.page = 1
          this.limit = 10
          this.totalCounts = 0
        } 
        this.searchPageList()
      },
    // 查询page列表
    async searchPageList() {
      var param = {
        page: this.page,
        limit: this.pageCount,
        startDate: this.createTime.from,
        endDate: this.createTime.to,
      };
      // 把查询条件存入缓存
      const data = await operationLogSearch(param);
      if (data.data.operationSearchList) {
        this.pageList = data.data.operationSearchList;
      }

      this.totalCount = data.data.totalCount;     
      this.totalPages = Math.ceil(this.totalCount / this.pageCount);
      
      if (this.page > this.totalPages && this.totalPages > 0) {
        this.page = 1;
        this.doSearch(true);
      }
    },
    startDateChange(value) {
      this.createTime.from = value;
    },
    endDateChange(value) {
      this.createTime.to = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  max-width: 30%;
}
.date-pick {
  max-width: 20%;
}
.search {
  max-width: 60%;
}
.v-input.account-info-input.v-input--hide-details.theme--light.v-text-field.v-text-field--single-line.v-text-field--is-booted {
  margin-top: 0;
  padding-top: 0;
}
.v-input.account-info-input.v-input--hide-details.theme--light.v-text-field.v-text-field--is-booted {
  margin-top: 0;
  padding-top: 0;
}
.v-input.station-select.theme--light.v-text-field.v-text-field--is-booted.v-select {
  margin-top: 0;
  padding-top: 0;
}
.tb-no-padding {
  padding: 0 12px;
}
.v-card {
  margin-top: 0px;
  margin-bottom: 0px;
}
.v-btn.v-size--default {
  font-size: 15px;
}
.v-btn.v-size--small {
  font-size: 12px;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 16px;
  font-weight: bold;
  color: black;
}
::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}
::v-deep .theme--light.v-data-table {
  color: black;
}
::v-deep .v-data-footer {
  font-size: 14px;
  color: black;
}
.topAndBottom {
  padding-bottom: 0px;
  padding-top: 0px;
}
.top {
  padding-top: 0px;
}
.bottom {
  padding-bottom: 0px;
}
.search-result {
  display: block;
  position: relative;
  margin: 2em 2em 0.5em 2em;
}
.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}
.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-reset {
  margin: 0 10px 0 10px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  margin: 0 10px 0 20px;
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
</style>
